//#region libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectHideCompletedFlights, setHideCompletedFlights } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const HideCompletedFlightsSwitch = () => {

    //redux
    const dispatch = useDispatch();
    const hideCompletedFlights = useSelector(selectHideCompletedFlights);   // status of hide completed flights switch
    const usedTheme = useSelector(selectUsedTheme);

    const handleSwitch = () => {
        dispatch(setHideCompletedFlights(!hideCompletedFlights));
    }

    return (

        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Hide Completed Flights
                </span>
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={hideCompletedFlights}
                    value={hideCompletedFlights}
                    style={{ marginLeft: "16px" }}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Hide flights from the timeline once all their passenger tasks are completed. Flights with an open task or an unassigned passenger stay visible.
            </span>
        </div>


    )
}

export default HideCompletedFlightsSwitch
